export const ACTIONS_OZON = {
  ADD_PRODUCTS: 'ADD_OZON_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_OZON_PRODUCT',
  CHANGE_MARKET: 'CHANGE_OZON_MARKET',
};

export const addOzonProducts = data => ({
  type: ACTIONS_OZON.ADD_PRODUCTS,
  data,
});

export const actionChangeOzonProduct = (product = {}) => ({
  type: ACTIONS_OZON.CHANGE_PRODUCT,
  product,
});

export const changeOzonMarket = market => ({
  type: ACTIONS_OZON.CHANGE_MARKET,
  market,
});